/* eslint-disable import/prefer-default-export */

const WEBHOOK_EVENT_PATTERNS = [
  /_PARTNER_WEBHOOK_(SUCCESS|FAILURE)$/,
  /^SHIPMENT_VOIDED_WEBHOOK_(SUCCESS|FAILURE)$/,
];

export const isWebhookEvent = (actionItemType) =>
  !!actionItemType && WEBHOOK_EVENT_PATTERNS.some((pattern) => pattern.test(actionItemType));
